module.exports = __webpack_public_path__ + "static/media/member-button.eec73288.png";